module.exports = __webpack_public_path__ + "img/SUPER_DRAGON.f15ddfe9.png";